export default __webpack_public_path__ + "static/media/home-yoga-meditation-slider-bg.81103c43.jpg";